import * as React from 'react';
import { ImageField, Show, ShowProps, SimpleShowLayout, TextField } from 'react-admin';
import { TranslateField } from '../components/TranslateField';

export const BillboardShow = (props: ShowProps): React.ReactElement => {
	return (
		<Show {...props}>
			<SimpleShowLayout>
				<TextField source="id" label="#"/>
				<ImageField source="featuredImageUrl" label="FEATURED_IMAGE"/>
				<TextField source="title" label="TITLE"/>
				<TranslateField source="language" label="LANGUAGE"/>
			</SimpleShowLayout>
		</Show>
	);
};
